<template>
    <div>
        <div id="reader" style="width: 500px;"></div>
    </div>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
    name: "QrScanner",
    data() {
        return {
            scannedResult: "",
        };
    },
    mounted() {
        const html5QrCode = new Html5Qrcode("reader");
        const config = { fps: 10, qrbox: 250 };

        html5QrCode
            .start(
                { facingMode: "environment" },
                config,
                (qrMessage) => {
                    this.scannedResult = qrMessage;

                    html5QrCode
                        .stop()
                        .then(() => {
                            window.location.href = qrMessage;
                        })
                        .catch((err) => {
                            console.error("Failed to stop scanning:", err);
                        });
                },
                (errorMessage) => {
                    if (errorMessage.includes("NotFoundException")) {
                        return;
                    }
                    console.warn("QR Code scan error:", errorMessage);
                }
            )
            .catch((err) => {
                console.error("Unable to start scanning.", err);
            });
    },
};
</script>

<style scoped>
#reader {
    border: 2px solid #ddd;
    margin: 1rem 0;
}
</style>
